import * as React from 'react'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useQuery } from 'react-query'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'

export const SoldServiceStatusesProvider: React.FC<IProviderProps> = ({
  render,
}) => {
  const { data, isFetching } = useQuery(
    ['filters', 'opp', 'soldServiceStatuses'],
    async (): Promise<IOption[]> => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'opportunities',
          'SoldServiceStatuses',
        )}`,
      )

      const statuses: string[] = await result.json()

      const options: IOption[] = statuses.map((status) => ({
        value: status,
        label: status,
      }))

      return options
    },
  )

  return <>{render(data ?? [], isFetching)}</>
}
SoldServiceStatusesProvider.displayName = 'SoldServiceStatusesProvider'
